<template>
    <div class="modal" style="z-index: 12345; background: rgba(1,1,1,0.5);padding-top: 50px;" :style="bgStyle">
        <div style="margin:0 auto;overflow-y:auto;background: white;width:100%;max-height:calc(100% - 34px);"
            :style="contentBg">
            <div class="agx-theme-bg" style="position: -webkit-sticky;position:sticky;top:0px; text-align:right;border-bottom: 1px solid gray;z-index: 10;">
                <span class="btn btn-default" @click="closeClicked">X</span>
            </div>
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        "show": Boolean,
        "modalStyle": { type: Object, default: null },
        "contentStyle": { type: Object, default: null }
    },
    computed: {
        bgStyle: function () {
            return { display: this.show ? "block" : "none", ...this.modalStyle }
        },
        contentBg: function () {
            return { ...this.contentStyle }
        }
    },
    data: function () {
        return {

        };
    },
    methods: {
        closeClicked: function () {
            this.$emit("onclose");
        }
    },
    created: function () {

    }
}
</script>